import React, { useState, useEffect, useContext, useRef } from "react";
import { store } from "../../context/store";
import { functions } from "../../constants/common-functions";
import { useHistory } from "react-router-dom";
import Header from "../../components/Header";
import LeftMenu from "../../components/LeftMenu";
import { SYSTEM_BLUE_BACKGROUND_LIGHT, COLOR_GRAY_BANNER_BACKGROUND } from "../../constants/colors";
import {BASE_INPUT_ROW, BASE_LABEL_DARK, BASE_SELECT_DARK, BASE_SELECT_FIRST_OPTION } from "../../constants/styles";
import {UNSET} from "../../constants/general-constants";
import DashboardSelector from "../../components/DashboardSelector";
import {childDashboardsUtilisation} from "../../constants/dashboards-children";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import {COLOR_DASHBOARD_BACKGROUND} from "../../constants/colors";
import {NON_HERO_BACKGROUND} from "../../constants/styles";
import {CARD_STYLE} from "../../constants/styles";
import {DEFAULT_BLUE_GRADIENT} from "../../constants/styles";
import AmChartRingIndicator from "../../components/AmChartRingIndicator";
import {COLOR_UTILISATION_OCCUPIED} from "../../constants/colors";
import {COLOR_UTILISATION_SIGNS_OF_LIFE} from "../../constants/colors";

am4core.useTheme(am4themes_animated);

export default function UtilisationSensors() {
	
  const globalState = useContext(store);
  const { dispatch } = globalState;
  const history = useHistory();

  const [loaded, setLoaded] = useState(false);
  const [dashboardData, setDashboardData] = useState(null);
  const [dimension, setDimension] = useState("desk");
  const [facilities, setFacilities] = useState([]);
  const [floors, setFloors] = useState([]);
  const [floorZones, setFloorZones] = useState([]);
  const [facilityId, setFacilityId] = useState(UNSET);
  const [floorId, setFloorId] = useState(UNSET);
  const [floorZoneId, setFloorZoneId] = useState(UNSET);
  const [utilisationSurvey, setUtilisationSurvey] = useState(0);
  const [utilisationSensor, setUtilisationSensor] = useState(0);

  // refs for chart disposal
  const surveyDoughnutRef = useRef(null);
  const sensorDoughnutRef = useRef(null);
  const deltaDoughnutRef = useRef(null);
  const discrepancyPercentRef = useRef(null);
  const discrepancyNumberRef = useRef(null);
  const timelineRef = useRef(null);
  
  //Chart Ids
  const ID_DOUGHNUT_INDICATOR_SURVEY = "ID_DOUGHNUT_INDICATOR_SURVEY";
  const ID_DOUGHNUT_INDICATOR_SENSOR = "ID_DOUGHNUT_INDICATOR_SENSOR";
  const ID_CHART_BAR_DISCREPANCY_TOP_PERCENT = "ID_CHART_BAR_DISCREPANCY_TOP_PERCENT";
  const ID_CHART_BAR_DISCREPANCY_TOP_NUMBER = "ID_CHART_BAR_DISCREPANCY_TOP_NUMBER";
  const ID_CHART_BAR_TIMELINE = "ID_CHART_BAR_TIMELINE";
  
  //Styles
  const thisContainer = {display: "flex",position: "fixed",flexDirection: "column",width: "100%",minHeight: "100vh",left: "0px",top: "0px"};
  const mainContainer = {backgroundColor:NON_HERO_BACKGROUND, display: "flex",position: "fixed",top: "0px",left: "60px",bottom: "0px",right: "0px",flexDirection: "column",overflow: "auto"};
  const topRow = { display: "flex", width: "100%" };
  const topLeft = { display: "flex", width: "430px", flexDirection: "column",  
  background: "linear-gradient(180deg, #1a1d22 0%, #0f1115 60%, #0d1622 100%)",
  boxShadow: "2px 0 12px rgba(0,0,0,0.6)", color:'white' };
  const inputPanel = {
    display: 'flex',
    flexDirection: 'column',
    width: 'calc(100% - 60px)',
    marginLeft: '20px',
    marginTop: '20px',
    marginBottom: '0px',
    padding: '12px',
    borderRadius: '10px',

    // ✅ New look
    background: 'linear-gradient(180deg, #1a1d22 0%, #0f1115 100%)',
    border: '1px solid rgba(255,255,255,0.08)',
    boxShadow: '0 6px 16px rgba(0,0,0,0.35)'
  };
  const topRight = {display: "flex",width: "calc(100% - 400px)", paddingTop:'60px',flexDirection: "column",overflow: "auto",height: "calc(100vh - 0px)"};
  const toggleContainer = { display: "flex", alignItems: "center", width: "100%", justifyContent: "space-around" };
  const doughnutTitle = {display: "flex",alignSelf: "center",fontSize: "12px",color: "lightgrey",fontWeight: "bold"};
  const infoPanel = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "40px",
    marginLeft: "20px",
    marginRight: "20px",
    marginTop: "20px",
    fontSize: "14px",
    fontWeight: "600",
    borderRadius: "10px",

    // ✅ New look
    background: 'rgba(255,255,255,0.04)',
    border: '1px solid rgba(255,255,255,0.08)',
    boxShadow: '0 4px 10px rgba(0,0,0,0.25)',
    color: "#e5e7eb"
  };
  
  useEffect(() => {
    if (!loaded) {
      loadDashboard();
      loadFacilities();
      setLoaded(true);
    }
  }, [loaded]);
  
  useEffect(() => {
  	if (!loaded) return; 
	  loadDashboard();
	  if (facilityId !== UNSET) {
		    loadFloors();
		  } else {
		    setFloors([]); // clear floors when UNSET
		  }
	}, [facilityId]);
		
	useEffect(() => {
		if (!loaded) return; 
		  loadDashboard();
		  if (floorId !== UNSET) {
		    loadFloorZones();
		  } else {
		    setFloorZones([]); // clear zones when UNSET
		  }
	}, [floorId]);
		
	useEffect(() => {
		if (!loaded) return; 
		  loadDashboard();
	}, [floorZoneId]);


  // Sensor doughnut
  useEffect(() => {
    if (dashboardData) {
      setUtilisationSurvey(dashboardData.headline.surveyUtilisationPct);
	  setUtilisationSensor(dashboardData.headline.sensorUtilisationPct);
    }
  }, [dashboardData]);


  // Discrepancy top % diff
  useEffect(() => {
    if (dashboardData) {
      let data = [];
      if (dimension === "desk") {
        data = dashboardData.topDesks?.map(d => ({ ...d, label: d.label }));
      } else if (dimension === "floor") {
        data = dashboardData.topFloors?.map(f => ({ ...f, label: f.floorName || f.label }));
      } else if (dimension === "floor_zone") {
        data = dashboardData.topFloorsZones?.map(z => ({ ...z, label: z.zoneName || z.label }));
      } else {
        data = dashboardData.topBuildings?.map(b => ({ ...b, label: b.buildingName || b.label }));
      }

      if (discrepancyPercentRef.current) discrepancyPercentRef.current.dispose();

      let chart = am4core.create(ID_CHART_BAR_DISCREPANCY_TOP_PERCENT, am4charts.XYChart);
      discrepancyPercentRef.current = chart;
      chart.rotate = true;
      chart.data = data;

      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
			categoryAxis.dataFields.category = "label";
			categoryAxis.renderer.inversed = true;
			categoryAxis.renderer.labels.template.fontSize = 10;
			categoryAxis.renderer.labels.template.rotation = 270;
			categoryAxis.renderer.labels.template.horizontalCenter = "right";
			categoryAxis.renderer.labels.template.verticalCenter = "middle";
			categoryAxis.renderer.minGridDistance = 15;
			
			let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
			valueAxis.title.text = "% Difference (Survey - Sensor)";
			valueAxis.title.fontSize = 12;
			valueAxis.title.fontWeight = "bold";
			valueAxis.renderer.labels.template.fontSize = 10;

      let series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = "avgPctDiff";
      series.dataFields.categoryX = "label";
	  series.fill = am4core.color("#2196f3");
	  series.stroke = am4core.color("#2196f3");
      series.columns.template.tooltipText = "{label}: [bold]{avgPctDiff.formatNumber('#.0')}%[/]";
    }
  }, [dashboardData, dimension]);

  // Discrepancy mismatch count
  useEffect(() => {
    if (dashboardData) {
      let data = [];
      if (dimension === "desk") {
        data = dashboardData.topDesks?.map(d => ({ ...d, label: d.label }));
      } else if (dimension === "floor") {
        data = dashboardData.topFloors?.map(f => ({ ...f, label: f.floorName || f.label }));
      } else if (dimension === "floor_zone") {
        data = dashboardData.topFloorsZones?.map(z => ({ ...z, label: z.zoneName || z.label }));
      } else {
        data = dashboardData.topBuildings?.map(b => ({ ...b, label: b.buildingName || b.label }));
      }

      if (discrepancyNumberRef.current) discrepancyNumberRef.current.dispose();

      let chart = am4core.create(ID_CHART_BAR_DISCREPANCY_TOP_NUMBER, am4charts.XYChart);
      discrepancyNumberRef.current = chart;
      chart.rotate = true;
      chart.data = data;

      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
			categoryAxis.dataFields.category = "label";
			categoryAxis.renderer.inversed = true;
			categoryAxis.renderer.labels.template.fontSize = 10;
			categoryAxis.renderer.labels.template.rotation = 270;
			categoryAxis.renderer.labels.template.horizontalCenter = "right";
			categoryAxis.renderer.labels.template.verticalCenter = "middle";
			categoryAxis.renderer.minGridDistance = 15;
			
			let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
			valueAxis.title.text = "Mismatch Count";
			valueAxis.title.fontSize = 12;
			valueAxis.title.fontWeight = "bold";
			valueAxis.renderer.labels.template.fontSize = 10;

      let series = chart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueY = "mismatchCount";
      series.dataFields.categoryX = "label";
	  series.fill = am4core.color(COLOR_UTILISATION_SIGNS_OF_LIFE);
	  series.stroke = am4core.color(COLOR_UTILISATION_SIGNS_OF_LIFE);
      series.columns.template.tooltipText = "{label}: [bold]{mismatchCount.formatNumber('#.0')}[/]";
    }
  }, [dashboardData, dimension]);

  // Timeline
  useEffect(() => {
    if (dashboardData) {
      if (timelineRef.current) timelineRef.current.dispose();
      let chart = am4core.create(ID_CHART_BAR_TIMELINE, am4charts.XYChart);
      timelineRef.current = chart;

      let timelineData = dashboardData.timeline.map(item => ({
        observationTs: new Date(item.observationTs),
        surveyUtilisationPct: item.surveyUtilisationPct,
        sensorUtilisationPct: item.sensorUtilisationPct
      }));
      chart.data = timelineData;

      chart.dateFormatter.inputDateFormat = "yyyy-MM-dd HH:mm";

      let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.labels.template.fontSize = 10;
      dateAxis.renderer.minGridDistance = 15;
      dateAxis.baseInterval = { timeUnit: "hour", count: 1 };
      dateAxis.renderer.labels.template.rotation = 270;
      dateAxis.renderer.labels.template.horizontalCenter = "right";
      dateAxis.renderer.labels.template.verticalCenter = "middle";

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.title.text = "Utilisation %";
      valueAxis.title.fontSize = 12;
      valueAxis.title.fontWeight = "bold";
      valueAxis.renderer.labels.template.fontSize = 10;

      let surveySeries = chart.series.push(new am4charts.ColumnSeries());
			surveySeries.dataFields.valueY = "surveyUtilisationPct";
			surveySeries.dataFields.dateX = "observationTs";
			surveySeries.name = "Survey";
			surveySeries.strokeWidth = 0;
			surveySeries.fill = am4core.color(COLOR_UTILISATION_SIGNS_OF_LIFE);
			surveySeries.columns.template.width = am4core.percent(40);
			surveySeries.clustered = true;
			surveySeries.tooltipText = "{dateX.formatDate('dd-MMM HH:mm')}: [bold]{valueY}%[/]";
			
			let sensorSeries = chart.series.push(new am4charts.ColumnSeries());
			sensorSeries.dataFields.valueY = "sensorUtilisationPct";
			sensorSeries.dataFields.dateX = "observationTs";
			sensorSeries.name = "Sensor";
			sensorSeries.strokeWidth = 0;
			sensorSeries.fill = am4core.color("#2196f3");
			sensorSeries.columns.template.width = am4core.percent(40);
			sensorSeries.clustered = true;
			sensorSeries.tooltipText = "{dateX.formatDate('dd-MMM HH:mm')}: [bold]{valueY}%[/]";

      chart.legend = new am4charts.Legend();
      chart.legend.labels.template.fontSize = 12;
      chart.legend.markers.template.width = 12;
      chart.legend.markers.template.height = 12;
      chart.cursor = new am4charts.XYCursor();
    }
  }, [dashboardData]);
  
  const loadDashboard = () => {functions.getObjectFromAjax("/resolutionsoftwareplatform/dashboard/utilisation/discrepancy-dashboard?facilityId=" + facilityId + "&floorId=" + floorId + "&floorZoneId=" + floorZoneId,null,populateObject);};
  const populateObject = function (obj) {setDashboardData(obj);};
  const loadFacilities = () => {functions.getArrayFromAjax("/resolutionsoftwareplatform/dashboard/common/dropdowndata/facilitieswithutilisation", setFacilities, null);}
  const loadFloors = () => {functions.getArrayFromAjax("/resolutionsoftwareplatform/dashboard/common/dropdowndata/floors?facilityId=" +facilityId, setFloors, null);}
  const loadFloorZones = () => {functions.getArrayFromAjax("/resolutionsoftwareplatform/dashboard/common/dropdowndata/floorzones?floorId=" + floorId, setFloorZones, null);}

	const optionFacilities = facilities.map((item, index) => <option style={{color:'black'}} value={item.id}>{item.name}</option>);
	const optionFloors = floors.map((item, index) => <option style={{color:'black'}} value={item.id}>{item.name}</option>);
	const optionFloorZones = floorZones.map((item, index) => <option style={{color:'black'}} value={item.id}>{item.name}</option>);

	const handleChangeFacility = (e) => {setFacilityId(e.target.value)};
	const handleChangeFloor = (e) => {setFloorId(e.target.value)};
	const handleChangeFloorZone = (e) => {setFloorZoneId(e.target.value)};

  return (
    <div style={thisContainer}>
      <Header transitionHide={true}/>
      <LeftMenu />
      <DashboardSelector
					title="Sensor Data"
					childDashboards={childDashboardsUtilisation}
				/>
      <div style={mainContainer}>
        <div style={topRow}>
          <div style={topLeft}>
          	<div style={inputPanel}>
          		<div style={BASE_INPUT_ROW}>
          			<div style={BASE_LABEL_DARK}>
          				Building
          			</div>
          			<select style={BASE_SELECT_DARK} onChange={handleChangeFacility}>
          				<option style={{color:'black'}} value={UNSET}>{BASE_SELECT_FIRST_OPTION}</option>
          				{optionFacilities}
          			</select>
          		</div>
          		<div style={BASE_INPUT_ROW}>
          			<div style={BASE_LABEL_DARK}>
          				Floor
          			</div>
          			<select style={BASE_SELECT_DARK} onChange={handleChangeFloor}>
          				<option style={{color:'black'}} value={UNSET}>{BASE_SELECT_FIRST_OPTION}</option>
          				{optionFloors}
          			</select>
          		</div>
          		<div style={BASE_INPUT_ROW}>
          			<div style={BASE_LABEL_DARK}>
          				Floor Zones
          			</div>
          			<select style={BASE_SELECT_DARK} onChange={handleChangeFloorZone}>
          				<option style={{color:'black'}} value={UNSET}>{BASE_SELECT_FIRST_OPTION}</option>
          				{optionFloorZones}
          			</select>
          		</div>
          	</div>
            <div style={infoPanel}>
              Total Sensors: {dashboardData ? functions.formatNumber(dashboardData.headline.totalSensors, 0) : "-"}
            </div>
			<div style={{display:'flex', width:'100%', alignItems:'center', justifyContent:'space-around', marginTop:'40px'}}>
				<AmChartRingIndicator
				   percentage={utilisationSurvey}
				   width={130}
				   height={130}
				   icon="chair"
				   color={COLOR_UTILISATION_OCCUPIED}
				   label="Survey"
				   id="utilisationsensor1"
				/>
			</div>											
										
           
            <div style={doughnutTitle}>Utilisation (Survey)</div>
			<div style={{display:'flex', width:'100%', alignItems:'center', justifyContent:'space-around', marginTop:'40px'}}>
							<AmChartRingIndicator
							   percentage={utilisationSensor}
							   width={130}
							   height={130}
							   icon="chair"
							   color={COLOR_UTILISATION_OCCUPIED}
							   label="Sensor"
							   id="utilisationsensor2"
							/>
						</div>		
            <div style={doughnutTitle}>Utilisation (Sensor)</div>
            <div style={infoPanel}>
              Difference: {dashboardData 
							  ? `${functions.formatNumber(
							        dashboardData.headline.sensorUtilisationPct - dashboardData.headline.surveyUtilisationPct, 
							        0
							      ) > 0 ? "+" : ""}${functions.formatNumber(
							        dashboardData.headline.sensorUtilisationPct - dashboardData.headline.surveyUtilisationPct, 
							        0
							      )}%`
							  : "-"}
            </div>
          </div>
          <div style={topRight}>
            <div style={toggleContainer}>
              <div
                style={{
                  display: "flex",
                  borderRadius: "10px",
                  width: "600px",
                  height: "30px",
                  overflow: "hidden",
                  marginTop: "10px"
                }}
              >
                {["desk", "floor", "floor_zone", "building"].map((dim, index, arr) => (
                  <div
                    key={dim}
                    style={{
                      flex: 1,
                      color: "white",
                      textAlign: "center",
                      lineHeight: "30px",
                      fontSize: "14px",
                      cursor: "pointer",
                      borderLeft: index === 0 ? "none" : "1px solid #555",
                      borderTopLeftRadius: index === 0 ? "15px" : "0px",
                      borderBottomLeftRadius: index === 0 ? "15px" : "0px",
                      borderTopRightRadius: index === arr.length - 1 ? "15px" : "0px",
                      borderBottomRightRadius: index === arr.length - 1 ? "15px" : "0px",
                      background: dimension === dim ? DEFAULT_BLUE_GRADIENT : COLOR_GRAY_BANNER_BACKGROUND
                    }}
                    onClick={() => {setDimension(dim);}}
                  >
                    {dim === "floor_zone"
                      ? "Floor Zones"
                      : dim.charAt(0).toUpperCase() + dim.slice(1) + "s"}
                  </div>
                ))}
              </div>
            </div>
			<div style={{...CARD_STYLE, marginTop:'10px', marginLeft:'30px', width:'calc(100% - 60px)'}}>
            	<div id={ID_CHART_BAR_DISCREPANCY_TOP_PERCENT} style={{ width: "100%", height: "26vh" }} />
			</div>
			<div style={{...CARD_STYLE, marginTop:'20px', marginLeft:'30px', width:'calc(100% - 60px)'}}>
            	<div id={ID_CHART_BAR_DISCREPANCY_TOP_NUMBER} style={{ width: "100%", height: "26vh" }} />
			</div>
			<div style={{...CARD_STYLE, marginTop:'20px', marginLeft:'30px', width:'calc(100% - 60px)'}}>
            	<div id={ID_CHART_BAR_TIMELINE} style={{ width: "100%", height: "26vh" }} />
			</div>
          </div>
		  
        </div>
      </div>
    </div>
  );
}

